export const changeTypeformUrl = (countryAnswerRef: string) => {
  const typeformFrame = document.querySelector("[data-testid='iframe']");
  const prevSrcValue = typeformFrame?.getAttribute('src');
  const newSrcValue = `${prevSrcValue}&#answers-countryOfWork=${countryAnswerRef}`;
  typeformFrame?.setAttribute('src', newSrcValue);

  return newSrcValue;
};
